import { useState, useEffect, createContext, useContext } from 'react';
import api from '../services/apiService';

const AuthContext = createContext();

function decodeToken(token) {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [perms, setPerms] = useState([]);

  useEffect(() => {
    const loadFromToken = () => {
      const token = sessionStorage.getItem('accessToken');
      if (!token) {
        setUser(null);
        setPerms([]);
        return;
      }

      setUser(decodeToken(token));

      api.get('/auth/me/permissions')
        .then(r => setPerms(r.data))
        .catch(() => setPerms([]));
    };

    const clearAuth = () => {
      setUser(null);
      setPerms([]);
    };

    loadFromToken();
    window.addEventListener('auth:login', loadFromToken);
    window.addEventListener('auth:tokenRefresh', loadFromToken);
    window.addEventListener('auth:logout', clearAuth);

    return () => {
      window.removeEventListener('auth:login', loadFromToken);
      window.removeEventListener('auth:tokenRefresh', loadFromToken);
      window.removeEventListener('auth:logout', clearAuth);
    };
  }, []);

  return (
    <AuthContext.Provider value={{ user, perms, setPerms }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export const usePerms = () => {
  const { perms, setPerms } = useAuth();

  const loadPerms = (permissions) => {
    setPerms(permissions);
  };

  const has = (route) => perms.includes(route);

  return { has, loadPerms };
};
